import { get, post, postExFile } from "@utils/httpUtil";
// 按医生 - 分页查询分发列表
export function findDistributeManageInfo(data, config) {
  return post(`/c/pc/deliver/communityUser/deliverPage`, data, config);
}
// 按商品 - 分页查询分发列表
export function findDistributeManageInfoByGoods(data, config) {
  return post(`/c/pc/deliver/communityGoods/deliverPage`, data, config);
}
// 指定商品新增分发医生 notExistGoodsId=商品id ?
// 指定商品删除分发医生 existGoodsId=商品id
export function doctorPageInfoAction(data, config) {
  return post(`/c/pc/community/doctor/v2/getPageInfo`, data, config);
}
// 查询操作记录信息
export function findOperationRecordsInfo(data, config) {
  return post(`/c/pc/deliver/communityUser/pageOperation`, data, config);
}
// 药品操作弹窗药品列表查询
export function findDrugOperationsListInfo(data, config) {
  //data.parentCatalogCode = 1000;
  return post(`/c/pc/deliver/communityUser/communityDoctorGoods`, data, config);
}
// 获取分类树
export function getGoodsCatalogTree(data, config) {
  return post(`/c/pc/deliver/drug/tree`, data, config);
}
// 药品分发社区医生
// 批量分发，批量删除
export function deliverCommunityDoctor(data, config) {
  return post(`/c/pc/deliver/communityUser/deliverCommunityDoctor`, data, config);
}
// 查询医生分发药品清单
export function findDoctorDistributeDrugList(data, config) {
  return post(`/c/pc/deliver/communityUser/pageDoctorList`, data, config);
}
// 社区医生分发药品清单Excel导出
export function exportPageDoctorListExcel(data, config) {
  return postExFile("/c/pc/deliver/communityUser/exportPageDoctorListExcel", data, config);
}
// 修改药品清单Excel导出
export function exportPageDoctorOpListtExcel(data, config) {
  return postExFile("/c/pc/deliver/communityUser/exportPageDoctorOpListtExcel", data, config);
}
// 分发操作记录列表Excel导出
export function exportPageOperationExcel(data, config) {
  return postExFile("/c/pc/deliver/communityUser/exportPageOperationExcel", data, config);
}
// 查询修改药品清单
export function findModifyDrugList(data, config) {
  return post(`/c/pc/deliver/communityUser/pageDoctorOpList`, data, config);
}
// 药品分发管理Excel导出
export function exportDeliverPageExcel(data, config) {
  return postExFile("/c/pc/deliver/communityUser/exportDeliverPageExcel", data, config);
}
// 分页获取库存管理药品信息
export function findInventoryManagePage(data, config) {
  return post(`/c/pc/deliver/drug/page`, data, config);
}
// 设置社区商品描述
export function setCommunityGoodsDescription(data, config) {
  return post(`/c/pc/deliver/drug/setCommunityGoodsDescription`, data, config);
}
// 根据商品id获取商品预估收益明细
export function findCommunityPredictProfit(data, config) {
  return post(`/c/pc/deliver/drug/findCommunityPredictProfit`, data, config);
}
// 根据商品id获取商品预估收益明细列表
export function findCommunityPredictProfitDetailList(data, config) {
  return post(`/c/pc/deliver/drug/findCommunityPredictProfitDetailList`, data, config);
}
// 根据id查询商品详情
export function findGoodsDetailInfoById(data, config) {
  return post(`/c/pc/deliver/drug/findById`, data, config);
}
// 重置社区禁售状态
export function resetForbid(data, config) {
  return post("/c/pc/deliver/drug/resetForbid", data, config);
}
// 导出药品信息
export function exportGoodsExcel(data, config) {
  return postExFile("/c/pc/deliver/drug/exportGoodsExcel", data, config);
}
// 分页查询销售药品列表
export function findSalesListInfo(data, config) {
  return post(`/c/pc/drug/sale/page`, data, config);
}
// 获取购药状态
export function getOrderStatus(data, config) {
  return get(`/c/pc/drug/sale/list/orderStatus`, data, config);
}
// 获取服务类型
export function getSourceType(data, config) {
  return get(`/c/pc/drug/sale/list/source`, data, config);
}
// 导出销售药品列表
export function exportSalesListExcel(data, config) {
  return postExFile("/c/pc/drug/sale/export", data, config);
}
// 用药指导分页列表
export function pageMedicationGuidanceRemindList(data, config) {
  return post(`/c/pc/drug/message/pageMedicationGuidanceRemindList`, data, config);
}
// 关怀提醒分页列表
export function pageCareRemindList(data, config) {
  return post(`/c/pc/drug/message/pageCareRemindList`, data, config);
}
// 续药提醒分页列表
export function pageContinuationMedicineRemindList(data, config) {
  return post(`/c/pc/drug/message/pageContinuationMedicineRemindList`, data, config);
}
// 查询用药提醒设置
export function getDeliverRemindConfig(data, config) {
  return post(`/c/pc/drug/message/getDeliverRemindConfig`, data, config);
}
// 编辑用药提醒设置
export function editDeliverRemindConfig(data, config) {
  return post(`/c/pc/drug/message/editDeliverRemindConfig`, data, config);
}
// 查看用药消息模板
export function getDeliverRemindTemplate(data, config) {
  return post(`/c/pc/drug/message/getDeliverRemindTemplate`, data, config);
}
// 通用-用药提醒分页列表导出
export function pageDeliverRemindListExport(data, config) {
  return postExFile(`/c/pc/drug/message/pageDeliverRemindListExport`, data, config);
}
// 通用-消息记录列表
export function deliverRemindMessageList(data, config) {
  return post(`/c/pc/drug/message/deliverRemindMessageList`, data, config);
}
// 通用-药品分类数据
export function getDrugClassificationTree(data, config) {
  return post(`/c/pc/dictionary/getDictionaryTree/V2`, data, config);
}
// 分页条件获取推荐药品列表
// export function findRecommendDrugPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`/c/pc/deliver/drug/recommend/page`, data, config);
// }
// 批量推荐/取消推荐社区药品
export function batchUpdateCommunityDrugRecommend(data, config) {
  return post(`c/pc/deliver/drug/recommend/batchUpdateCommunityDrugRecommend`, data, config);
}
// 社区推荐药品展示设置开关-查询
export function getRecommendConfigSetting(data, config) {
  return post(`c/pc/deliver/drug/recommend/configSetting/getConfig`, data, config);
}
// 编辑推荐药品展示配置
export function upDateRecommendConfigSetting(data, config) {
  return post(`c/pc/deliver/drug/recommend/configSetting/updateConfig`, data, config);
}
// 导出销售药品列表
export function exportRecommendGoodsExcel(data, config) {
  return postExFile("/c/pc/deliver/drug/recommend/exportGoodsExcel", data, config);
}
// 查询社区推荐药品数量
export function getRecommendCount(data, config) {
  return post("c/pc/deliver/drug/recommend/getRecommendCount", data, config);
}
// 分页查询未推荐检测商品列表
export function pageUnRecommendDetection(data, config) {
  return post(`/c/pc/deliver/drug/recommend/pageUnRecommendDetection`, data, config);
}
// 分页查询未推荐健康商品列表
export function pageUnRecommendHealth(data, config) {
  return post(`/c/pc/deliver/drug/recommend/pageUnRecommendHealth`, data, config);
}
// 批量推荐（健康商品或检测商品）
export function drugrecommendbatchAdd(data, config) {
  return post(`/c/pc/deliver/drug/recommend/batchAdd`, data, config);
}
// 批量取消推荐（健康商品或检测商品）
export function drugrecommendbatchRemove(data, config) {
  return post(`/c/pc/deliver/drug/recommend/batchRemove`, data, config);
}
// 查询社区已推荐商品数量
export function getRecommendCountV2(data, config) {
  return post(`/c/pc/deliver/drug/recommend/getRecommendCount/v2`, data, config);
}
// 分页查询已推荐列表
export function pageRecommend(data, config) {
  return post(`/c/pc/deliver/drug/recommend/pageRecommend`, data, config);
}
// 查询社区自动采纳商品设置
export function getCommunityGoodsAutoAcceptConfig(data, config) {
  return post(`/c/pc/deliver/drug/getCommunityGoodsAutoAcceptConfig`, data, config);
}
// 编辑社区自动采纳商品设置
export function editCommunityGoodsAutoAcceptConfig(data, config) {
  return post(`/c/pc/deliver/drug/editCommunityGoodsAutoAcceptConfig`, data, config);
}
// 商品后台类目列表
export function findGoodsCatalogList(data, config) {
  return post(`/c/pc/deliver/drug/findGoodsCatalogList`, data, config);
}
// 社区商品采纳操作
export function communityDrugAcceptOperate(data, config) {
  return post(`/c/pc/deliver/drug/communityDrugAcceptOperate`, data, config);
}
// 获取爱问健康云社区id
export function getDefaultDividedCommunityId(data, config) {
  return post(`/c/pc/community/getDefaultDividedCommunityId`, data, config);
}
// 便民药房
// 分页查询便民药房商品列表
export function healthyGoodsMallPage(data, config) {
  data.parentCatalogCode = 1000;
  return post("/c/pc/healthyGoodsMall/page", data, config);
}
// 通用-用药提醒分页列表导出
export function healthyGoodsMallExportGoodsExcel(data, config) {
  return postExFile("/c/pc/healthyGoodsMall/exportGoodsExcel", data, config);
}
// 推荐/取消推荐商品
export function healthyGoodsMallBatchUpdateCommunityDrugRecommend(data, config) {
  return post("/c/pc/healthyGoodsMall/batchUpdateCommunityDrugRecommend", data, config);
}
// 显示/隐藏商品
export function healthyGoodsMallBatchUpdateCommunityDrugShowStatus(data, config) {
  return post("/c/pc/healthyGoodsMall/batchUpdateCommunityDrugShowStatus", data, config);
}
// 社区便民药房展示设置开关-查询
export function healthyGoodsMallGetConfig(data, config) {
  return post("/c/pc/healthyGoodsMall/configSetting/getConfig", data, config);
}
// 编辑便民药房展示配置
export function healthyGoodsMallUpdateConfig(data, config) {
  return post("/c/pc/healthyGoodsMall/configSetting/updateConfig", data, config);
}
// 编辑便民药房展示配置
export function getSupplierList(data, config) {
  return post("/c/pc/deliver/drug/supplierList", data, config);
}
// 商品合集
// 分页查询商品合集列表
export function goodsCollectionPage(data, config) {
  return post("/c/pc/goods/collection/pageList", data, config);
}
// 分页合集操作
export function goodsCollectionOperate(data, config) {
  return post("/c/pc/goods/collection/operate", data, config);
}
// 商业投放
// 分页查询投放记录列表
export function recordsDeploymentPage(data, config) {
  return post("/c/pc/community/advert/page", data, config);
}
// 分页查询投放数据列表
export function recordsDeploymentDataPage(data, config) {
  return post("/c/pc/community/advert/queryCommunityAdvertStatisticsDataPage", data, config);
}
// 分页查询样品申领列表
export function sampleRequestPage(data, config) {
  return post("/c/pc/community/advert/findAdvertSampleClaimeRecordPage", data, config);
}
// 社区投放数据分页查询列表
export function advertStatisticsDataPage(data, config) {
  return post("/c/pc/community/advert/queryCommunityAdvertStatisticsDataPage", data, config);
}
// 投放数据列表DAOCHU
export function advertStatisticsDataPageExport(data, config) {
  return postExFile(`/c/pc/community/advert/queryCommunityAdvertStatisticsDataPageExport`, data, config);
}
// 样品申领列表DAOCHU
export function advertSampleClaimeRecordPageExport(data, config) {
  return postExFile(`/c/pc/community/advert/findAdvertSampleClaimeRecordPageExport`, data, config);
}
// 查询广告效果明细列表(分页)
export function findAdvertEffectRecordPage(data, config) {
  return post("/c/pc/community/advert/findAdvertEffectRecordPage", data, config);
}
// 查询表单收集数据列表(分页)
export function pageCommunityAdvertFromCollectData(data, config) {
  return post("/c/pc/community/advert/pageCommunityAdvertFromCollectData", data, config);
}
// 社区导出表单收集数据列表
export function exportCommunityAdvertFromCollectData(data, config) {
  return postExFile("/c/pc/community/advert/exportCommunityAdvertFromCollectData", data, config);
}
// 结束投放操作
export function endAdvertOperate(data, config) {
  return post("/c/pc/community/advert/endAdvertOperate", data, config);
}
// 样品申领发货
export function advertSampleShipped(data, config) {
  return post("/c/pc/community/advert/advertSampleShipped", data, config);
}
// 保存或更新广告管理
export function recordsDeploymentUpdate(data, config) {
  return post("/c/pc/community/advert/add", data, config);
}
// 保存或更新广告管理
export function recordsDeploymentById(data, config) {
  return post("/c/pc/community/advert/findById", data, config);
}
// 获取广告坑位
export function findPositionInfo(data, config) {
  return post("/c/admin/advert/findPositionInfo", data, config);
}
// 获取投放类型
export function findTypeById(data, config) {
  return post("/c/pc/community/advert/findTypeById", data, config);
}